import { isEmpty, isNil, omit } from "ramda";

import { sendBeacon } from "utils/fetch";
import {
  camelCaseToHyphen,
  camelCaseToUnderscore,
  upperCaseFirst,
} from "utils/format";

// loads "./check-event-definition.production.js" in production builds using the
// "NormalModuleReplacementPlugin" see production.js config for more details.
import checkEventDefinition from "./check-event-definition";

const trackEvent = (tracking) => {
  if (isEmpty(tracking) || isNil(tracking)) return;

  const trackingData = Object.keys(tracking).reduce((obj, key) => {
    obj[`tracking${upperCaseFirst(key)}`] = tracking[key]; // eslint-disable-line no-param-reassign
    return obj;
  }, {});

  if (window.dataLayer) {
    window.dataLayer.push({
      event: "dataLayerPush",
      ...trackingData,
    });
  }
};

const trackPlatformEvent = (tracking) => {
  if (isEmpty(tracking) || isNil(tracking)) return;

  trackEvent(tracking);

  if (tracking.action && tracking.object) {
    checkEventDefinition(tracking);

    const properties = omit(["object", "action"], tracking);
    const underscoredProperties = Object.keys(properties).reduce((obj, key) => {
      obj[camelCaseToUnderscore(key)] = properties[key]; // eslint-disable-line no-param-reassign
      return obj;
    }, {});

    sendBeacon("/api/events", {
      event: {
        action: tracking.action,
        object: tracking.object,
        properties: underscoredProperties,
      },
    });
  }
};

const trackingDataAttributes = (tracking) => {
  if (isEmpty(tracking) || isNil(tracking)) return {};

  return Object.keys(tracking).reduce((obj, key) => {
    obj[`data-tracking-${camelCaseToHyphen(key)}`] = tracking[key]; // eslint-disable-line no-param-reassign
    return obj;
  }, {});
};

export { trackEvent, trackingDataAttributes, trackPlatformEvent };
